import React from 'react'

import { css } from '@emotion/core'
import { useTheme } from 'emotion-theming'
import Relazsizes from 'relazsizes'

import Container from 'components/layouts/atoms/Container'
import SectionContainer from 'components/layouts/atoms/SectionContainer'
import Typography from 'components/common/atoms/Typography'
import TextLink from 'components/common/atoms/TextLink'

const koinworksIntroductionStyle = (theme: ThemeType) => css`
  .koinworks-intro {
    &__wrapper {
      &:first-of-type {
        margin-bottom: 32px;
      }
    }
    &__img {
      padding: 24px 28px;
      margin-bottom: 32px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1);
      img {
        width: 273px;
      }
    }
    &__text {
      h2 {
        margin: 0;
      }
      > p {
        margin-top: 8px;
      }
      div {
        margin-top: 16px;
        a:hover {
          color: ${theme.campus.aqua50};
        }
      }
    }
    @media screen and (min-width: 768px) {
      &__wrapper {
        display: flex;
        &:first-of-type {
          margin-bottom: 80px;
        }
      }
      &__img {
        padding: 70px 40px;
        margin: 0 40px 0 0;
        img {
          width: 400px;
        }
      }
      &__text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        div,
        p {
          margin-top: 24px !important;
        }
      }
    }
  }
`

const KoinworksIntroduction = () => {
  const theme: ThemeType = useTheme()
  return (
    <div className="koinworks-intro" css={koinworksIntroductionStyle(theme)}>
      <SectionContainer withPaddingBottom>
        <Container>
          <div className="koinworks-intro__wrapper">
            <div className="koinworks-intro__img">
              <Relazsizes dataSrc="/next-assets/images/koinworks/logo-koinworks.png" alt="Koinworks Logo" />
            </div>
            <div className="koinworks-intro__text">
              <Typography variant="title" level="2" tagName="h2" fontWeight="bold">
                Apa itu KoinWorks?
              </Typography>
              <Typography variant="paragraph" level="1" tagName="p">
                KoinWorks merupakan One Stop Financial Solution Platform dengan penggunaan machine learning yang
                inovatif. KoinWorks telah berizin dan diawasi Otoritas Jasa Keuangan (OJK).
              </Typography>
              <TextLink
                text="Lihat Selengkapnya"
                href="https://koinworks.com/super-app"
                linkProps={{
                  target: '_blank',
                  rel: 'noopener noreferrer',
                }}
              />
            </div>
          </div>
          <div className="koinworks-intro__wrapper">
            <div className="koinworks-intro__img">
              <Relazsizes dataSrc="/next-assets/images/koinworks/logo-koinpintar.png" alt="Koinpintar Logo" />
            </div>
            <div className="koinworks-intro__text">
              <Typography variant="title" level="2" tagName="h2" fontWeight="bold">
                Tentang KoinPintar
              </Typography>
              <Typography variant="paragraph" level="1" tagName="p">
                KoinPintar merupakan produk pinjaman pendidikan dari KoinWorks untuk mendukung terwujudnya Indonesia
                Pintar dan memudahkan Anda untuk mendapatkan akses pembiayaan pendidikan yang lebih terjangkau.
              </Typography>
              <TextLink
                text="Lihat Selengkapnya"
                href="https://koinpintar.com"
                linkProps={{
                  target: '_blank',
                  rel: 'noopener noreferrer',
                }}
              />
            </div>
          </div>
        </Container>
      </SectionContainer>
    </div>
  )
}

export default KoinworksIntroduction
